import { FC } from 'react';
// styles
import styles from './MobileWrapper.module.css';

const MobileWrapper: FC = ({ children }) => {
    return <div className={styles['container-content-mobile']}>{children}</div>;
};

export default MobileWrapper;
